/* eslint-disable react-hooks/exhaustive-deps */

import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import {Accordion, VerificationToggle} from '../../../components';
import EasyAuthApplication from './Application';
import CountryCombobox from '../../EasyOnboard/CountryCombobox';
import {EasyOnboardContext} from '../../../helpers/context';
import {connect, useSelector} from 'react-redux';
import * as Actions from '../../../store/actions';
import countryList from 'react-select-country-list';

const selectSingleWidget = state => state?.widgets?.singleWidget;
function Configuration({setApp, isLoading}) {
  const {easyAuthWidgetData, setEasyAuthWidgetData} =
    useContext(EasyOnboardContext);
  const singleWidget = useSelector(selectSingleWidget);

  const options = useMemo(() => countryList().getData(), []);
  const [country, setCountry] = useState(singleWidget?.widget?.country);
  const inputRef = useRef(null);
  const [appOpen, setAppOpen] = useState(false);
  const [supportEmail, setSupportEmail] = useState();

  useEffect(() => {
    if (!isLoading) {
      setCountry(singleWidget?.widget?.country);
      setEasyAuthWidgetData({
        ...easyAuthWidgetData,
        name: singleWidget?.widget?.name || '',
        country:
          singleWidget?.widget?.country?.length > 0
            ? singleWidget?.widget?.country
            : options?.map(c => c.value),
        support_email: singleWidget?.widget?.support_email || null,
      });
      setSupportEmail(!!singleWidget?.widget?.support_email || null);
    }
    return () => setCountry([...options]);
  }, [
    setEasyAuthWidgetData,
    singleWidget?.widget?.country?.length,
    singleWidget?.widget?.support_email,
  ]);

  return (
    <Accordion title="Configuration">
      <p className="text-xs text-body leading-[18px]">
        Configure your verification process to easily identify your users
      </p>
      <div className="my-2">
        <EasyAuthApplication setApp={setApp} setAppOpen={setAppOpen} />
        {!appOpen && (
          <p className="text-xs text-body leading-[18px]">
            Customize your widget with your brand logo and color
          </p>
        )}
      </div>
      <label data-smallerlabel="" className="relative mt-4 mb-2">
        <p className="flex items-center text-sm text-grey font-medium gap-[2px]">
          Country
        </p>
        <p className="text-xs text-body leading-[18px]">
          Provide verification services tailored to your customers&apos;
          location
        </p>
      </label>
      <CountryCombobox
        isLoading={isLoading}
        countryData={country}
        onChange={country => {
          setCountry(country);
          setEasyAuthWidgetData({
            ...easyAuthWidgetData,
            country: country?.map(c => c.value),
          });
        }}
      />
      <div className="flex justify-between mt-5 items-center">
        <label data-smallerlabel="" className="relative !text-sm text-grey">
          Add Support Email
        </label>
        <VerificationToggle
          isChecked={supportEmail}
          onCheck={value => {
            setEasyAuthWidgetData({
              ...easyAuthWidgetData,
              ...(value
                ? {support_email: easyAuthWidgetData?.support_email}
                : {support_email: null}),
            });
            setSupportEmail(value);
            value && inputRef.current.focus();
          }}
        />
      </div>
      <>
        <div className=" justify-between mt-2 w-full">
          <input
            ref={inputRef}
            type="email"
            name="email_support"
            value={supportEmail ? easyAuthWidgetData?.support_email : ''}
            placeholder={'support@domain.com'}
            onChange={e => {
              setEasyAuthWidgetData({
                ...easyAuthWidgetData,
                support_email: e.target.value,
              });
            }}
            disabled={!supportEmail}
            className={`${
              !supportEmail ? 'cursor-not-allowed' : 'focus:border-danger'
            }`}
          />
          <p
            className={`mt-2 text-xs ${
              !supportEmail ? 'text-grey5' : 'text-body'
            }`}
          >
            Add an email so your users can easily contact support
          </p>
        </div>
      </>
    </Accordion>
  );
}

export default connect(state => state, Actions)(Configuration);
